import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { SearchLoadFulfilledAction, SearchLoadMoreFulfilledAction } from '../../domains/searches/actions.types';

import { SearchResultNetworkQuestions } from './types';

export type SearchResultNetworkQuestionAction = SearchLoadFulfilledAction | SearchLoadMoreFulfilledAction;

const initialState: SearchResultNetworkQuestions = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<SearchResultNetworkQuestions, SearchResultNetworkQuestionAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'SEARCH.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.searchResultsNetworkQuestions);
    case 'SEARCH.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.searchResultsNetworkQuestions);
    default:
      return state;
  }
};

export default reducer;
